import * as React from 'react'

import { Scalars } from '~/common/types/graphql'

import { OptionRow } from './shared/components/selectElements'

interface Props {
  isActive?: boolean
  isSelected?: boolean
  value: Scalars['ID'] | number | null
  isCheckbox?: boolean
  disabled?: boolean
  style?: React.CSSProperties
  children?: React.ReactNode | ((value: any) => React.ReactNode)
}

const Option: React.FC<Props> = ({
  children,
  isActive,
  isSelected,
  isCheckbox,
  ...rest
}) => {
  return (
    <OptionRow
      isActive={isActive}
      isSelected={isSelected}
      isCheckbox={isCheckbox}
      {...rest}
    >
      {typeof children === 'function'
        ? children({ isSelected, ...rest })
        : children}
    </OptionRow>
  )
}

export default Option
